<template>
<div id="body" class="">
    <div class="cookie-disclaimer" v-if="!cookieDisclaimerHide">
        <button
            type="button"
            class="close-disclaimer"
            @click.prevent="disclaimerAccept(true)"
        >
            ×
        </button>
        Во время посещения данного сайта, КОГБУ «ЦГАКО» может
        использовать общеотраслевую технологию,
        называемую cookie. Файлы cookie представляют собой небольшие
        фрагменты данных, которые временно
        сохраняются на вашем компьютере или мобильном устройстве,
        и обеспечивают более эффективную работу сайта
        (<a href="https://ru.wikipedia.org/wiki/Cookie">подробнее о cookie</a>).
        Продолжая просматривать данный сайт, Вы соглашаетесь с
        <a href="https://cgako.ru/static/page_files/e55c13da5de511eaa0225254007c38a0.pdf">
          использованием файлов cookie
        </a>
        и принимаете условия.
        <br>
        <button
            type="button"
            class="accept"
            @click.prevent="disclaimerAccept(true)"
        >
            Подтверждаю ознакомление и согласие
        </button>
    </div>
    <!--<div id="warning">сайт в тестовом режиме</div>-->
    <div id="wrapper" class="">

        <a
          id="back-to-top"
          href="#"
          class="button icon solo fa-arrow-up hidden"
          v-scroll="backToTop"
          @click.prevent="scrollToTop"
        >
        </a>

        <header id="header">
            <b-link :to="{name: 'Index'}" class="logo">
              <img alt="Логотип" class="logo-img" src="../assets/images/archive_w_background.png"/>
              <div>
                <span class="naming">
                  Центральный<br/>
                </span>
                <span class="naming">
                  государственный<br/>
                </span>
                <span class="naming">
                  архив<br/>
                </span>
                <span class="naming">
                  Кировской<br/>
                </span>
                <span class="naming">
                  области<br/>
                </span>
                <span class="sml">на главную</span>
              </div>
            </b-link>
<div class="logo650">
<a href="https://650kirov.ru"><img src="../assets/images/kirov650.png" alt="banner-kirov650" class="logo650-img"/></a>
</div>
        </header>
        <nav id="nav" v-scroll="navStick" v-if="$screen.lg || $screen.xl">
          <NodeTree :node="menu" :search="searchActive"></NodeTree>
          <ul
            v-bind:class="['search', searchActive ? 'active' : '']"
          >
            <li>
              <input
                ref="searchInput"
                placeholder="Поиск по сайту"
                type="text"
                v-model="searchQuery"
                v-bind:class="['search_fld', searchActive ? 'active' : '']"
              >
            </li>
          </ul>

          <ul class="icons">
            <li
              v-bind:class="['go-search', searchActive ? '' : 'hidden']"
            >
<!--
              <a href="#" class="search_btn icon fa-arrow-right">
                <span class="label">Поиск</span>
              </a>
-->
              <router-link
                class="search_btn icon fa-arrow-right"
                :to="{ name: 'SearchResult', query: { q: searchQuery }}"
              >
                <span class="label">Поиск</span>
              </router-link>
            </li>
            <li>
              <a
                href="#"
                v-bind:class="['icon', searchActive ? 'fa-close' : 'fa-search']"
                @click.prevent="searchActive = !searchActive; searchQuery = ''"
              >
                <span class="label">Открыть/закрыть поисковую строку</span>
              </a>
            </li>
          </ul>
        </nav>
        <b-navbar
          toggleable
          id="navMobile"
          v-if="($screen.xs || $screen.sm) && (!$screen.lg || !$screen.xl)"
        >
          <b-navbar-toggle
            target="navbar-toggle-collapse"
            class="togglerTest"
          >
            <template v-slot:default="{ expanded }">
              Меню
              <font-awesome-icon v-if="expanded" icon="angle-up" fixed-width />
              <font-awesome-icon v-else icon="angle-down" fixed-width />
            </template>
          </b-navbar-toggle>

          <b-collapse id="navbar-toggle-collapse" is-nav>
            <ul class="search">
              <li>
                <input
                  ref="searchInput"
                  placeholder="Поиск по сайту"
                  type="text"
                  v-model="searchQuery"
                  class="search_fld"
                >
              </li>
              <li
                class="go-search"
              >
                <router-link
                  :to="{ name: 'SearchResult', query: { q: searchQuery }}"
                >
                  <font-awesome-icon icon="arrow-right" fixed-width />
                </router-link>
              </li>
            </ul>

            <NodeTree
              :node="menu"
              :search="searchActive"
              class="navbar-nav"
            ></NodeTree>
         </b-collapse>
        </b-navbar>

        <div id="main" v-if="this.$route.name==='Index'">
          <div class="banners">
            <carousel
              v-if="banners && banners.length > 0"
              :data="banners"
              :controls="false"
              :interval="15000"
              indicator-type="disc"
              class="w-100"
            >
            </carousel>

          </div>
          <div class="two-panels">
            <main class="firstpanel">
              <div class="header">
                  <h2>Анонсы и объявления</h2>
              </div>
              <div class="announces">
                  <carousel
                    v-if="announcements && announcements.length > 0"
                    :data="announcements"
                    :controls="false"
                    :interval="10000"
                    indicator-type="disc"
                    class="w-100"
                    :autoplay="false"
                    :slideOnSwipe="false"
                    :pauseOnEnter="false"
                  >
                  </carousel>
                  <div v-else>
                      На данный момент нет запланированных мероприятий, следите за обновлениями!
                  </div>
              </div>

              <div class="header">
                  <h2>Новое в архиве</h2>
              </div>

              <section class="posts">
                  <!--<article
                    v-for="page in lastPages"
                    v-bind:key="page.uri"
                    class="post"
                  >
                    <router-link
                      :to="{ name: 'SinglePage', params: { uri: page.uri }}"
                      class="image fit h-100"
                    >
                      <img v-if="page.cover"
                        :src="`/static/page_covers/${page.cover}`"
                      >
                      <header>
                        <span class="date">
                          {{$options.filters.moment(page.creation_date, 'MMMM DD, YYYY')}}
                        </span>
                        <h3 class="line-clamp pr-3 pl-3">
                          {{page.title}}
                        </h3>
                      </header>
                    </router-link>
                  </article>-->
                  <article
                    class="half-image"
                    v-for="page in lastPages"
                    v-bind:key="page.uri"
                  >
                    <header>
                      <span class="date">
                        {{$options.filters.moment(page.creation_date, 'MMMM DD, YYYY')}}
                      </span>
                      <h3>
                        <router-link
                          :to="{ name: 'SinglePage', params: { uri: page.uri }}"
                        >{{page.title}}</router-link>
                      </h3>
                    </header>
                    <router-link
                      :to="{ name: 'SinglePage', params: { uri: page.uri }}"
                      class="image fit"
                      v-if="page.cover"
                    >
                      <img :src="'/static/page_covers/'+page.cover" alt="" />
                    </router-link>
                    <p class="line-clamp mb-3">{{page.seo_description}}</p>
                    <router-link
                      :to="{ name: 'SinglePage', params: { uri: page.uri }}"
                      class="button w-100"
                    >Смотреть полностью</router-link>
                  </article>
              </section>
            </main>

              <div class="secondPanel">
<aside style="width:240px; height: 300px">
<div id="banner-gorod-sreda">
<img class="banner-gorod-sreda" src="../assets/images/6.png" alt="heroes" width="200" height="270"/>
</div>
</aside>
                  <aside>
                      <h3>Мы ВКонтакте:</h3>
                      <div id="vk_groups"></div>
                  </aside>
<div class="noborder">
<script type="text/javascript" src='https://pos.gosuslugi.ru/bin/script.min.js'>
</script>
<div id='js-show-iframe-wrapper'>
 <button type="button" id="btn_style" name="run_btn" onclick="window.open('https://pos.gosuslugi.ru/form','_blank', 'popup=yes')">
  <div class='pos-banner-fluid bf-46'>
    <div class='bf-46__content'>
      <div class='bf-46__description'>
        <span class='bf-46__text'>
           Есть вопрос?<br>Напишите нам!
        </span>
      </div>
      <div class='bf-46__logo-wrap'>
         <img class='bf-46__logo' src='https://pos.gosuslugi.ru/bin/banner-fluid/gosuslugi-logo-blue.svg' alt='Госуслуги'/>
          <div class='bf-46__slogan'>Решаем вместе</div>
      </div>
    </div>
  </div>
 </button>
</div>
<script type="text/javascript">Widget("https://pos.gosuslugi.ru/form", 337242)</script>
</div>
<aside style="padding-bottom:250px">
<div id="banner-gorod-sreda">
<a href="https://43.gorodsreda.ru/?utm_source=cur43&utm_medium=site">
<img class="banner-gorod-sreda" src="../assets/images/1.png" alt="banner" width="250" height="200"/>
</a>
</div>
</aside>
                  <aside>
                      <h3>Мероприятия:</h3>
                      <div class="iframe-container">
                          <!--<iframe src="https://pro.culture.ru/widgets/embed/js4dcgqpetd20cne" frameborder="0" scrolling="no"></iframe>-->
                          <iframe src="https://pro.culture.ru/widgets/embed/cgy0bcmbewe8xrmq" frameborder="0" scrolling="no"></iframe>

                      </div>
                  </aside>

                  <aside id="history-dates">
                      <h3>Памятные даты истории России:</h3>
                      <div class="box" v-for="event in historyEventsClosest" v-bind:key="event.id">
                          <div class="header">
                              <span class="history-date-time">
                                {{event.distance}}
                                ({{event.years}})
                              </span>
                              <h4>{{event.event_title}}</h4>
                          </div>
                          <div class="content">
                              <p>
                                {{event.description_text}}
                              </p>
                          </div>
                      </div>
                  </aside>
              </div>

          </div>

<!--
          <section>
              <h4>Дополнительный блок</h4>
          </section>
-->
        </div>

        <router-view v-else></router-view>

        <footer id="footer">
          <!--<section>
              <h4>Обратная связь</h4>
              <form method="post" action="#">
                  <div class="fields">
                      <div class="field">
                          <label for="name">Ваше имя</label>
                          <input type="text" name="name" id="name" />
                      </div>
                      <div class="field">
                          <label for="email">Email</label>
                          <input type="text" name="email" id="email" />
                      </div>
                      <div class="field">
                          <label for="message">Ваше сообщение</label>
                          <textarea name="message" id="message" rows="3"></textarea>
                      </div>
                  </div>
                  <ul class="actions">
                      <li><input type="submit" value="Отправить сообщение" /></li>
                  </ul>
              </form>
          </section>-->
          <section>
              <h4>Оставьте отзыв:</h4>
              <h5>На Яндекс:</h5>
              <iframe src="https://yandex.ru/sprav/widget/rating-badge/1014916027" height="50" width="150" frameborder="0"></iframe>
          </section>


          <section class="contact">
              <h4>Контактная информация:</h4>

              <h5>Адрес</h5>
              <a href="#">
                Юридический адрес (главный корпус): 610027,
                г. Киров, ул. Карла Маркса, д. 142
              </a>

              <h5>Телефон</h5>
              <a href="tel:+7 (8332) 67‒36‒89">+7 (8332) 67‒36‒89</a>

              <h5>Email</h5>
              <a href="mailto:gako-kirov@yandex.ru">gako-kirov@yandex.ru</a>

              <h5>Соц. сети</h5>
              <ul class="icons alt">
                  <li>
                    <a href="https://vk.com/cgako" class="icon alt fa-vk">
                      <span class="label">VK</span>
                    </a>
                  </li>
                  <li>
                    <a href="#" class="icon alt fa-instagram">
                      <span class="label">Instagram</span>
                    </a>
                  </li>
              </ul>
          </section>

          <section class="colleagues">
            <h4>Полезные ссылки:</h4>
            <ul class="colleagues-list">
              <li>
                <a class="fed_archives" href="http://archives.ru" title="Федеральное архивное агентство"></a>
              </li>
              <li>
                <a class="fed_archives_portal" href="http://www.rusarchives.ru" title="Портал архивы России"></a>
              </li>
              <li>
                <a class="kirov_government" href="https://kirovreg.ru" title="Правительство Кировской области"></a>
              </li>
              <li>
                <a class="kirov_minkult" href="http://cultura.kirovreg.ru/" title="Министерство культуры Кировской области">
                </a>
              </li>
              <li>
                <a class="gosuslugi" href="https://www.gosuslugi.ru" title="Государственные услуги"></a>
              </li>
              <li>
                <a class="goszakupki" href="http://zakupki.gov.ru" title="Государственные закупки"></a>
              </li>
              <li>
                <iframe src="https://pro.culture.ru/widgets/embed/pe22d82mkynxy4sr" frameborder="0" height="60"></iframe>
              </li>
              <li>
                <a class="grantsculture" href="https://grants.culture.ru" title="Культура. Гранты России"></a>
              </li>
            </ul>
          </section>
        </footer>

<div id="copyright">
  <ul>
    <li>&copy; {{copyDate}} КОГБУ «ЦГАКО»</li>
    <li>Использование материалов сайта без согласования с КОГБУ «ЦГАКО» запрещено</li>
  </ul>
</div>

    </div>

</div>

</template>

<style lang="css">
@import '../assets/style-admin.css';
@import '../assets/css/main.css';
@import '../assets/css/noscript.css';
@import '../assets/css/widget1.css';
@import '../assets/css/banner-gorod-sreda.css';
@import '../assets/css/logo650.css';

div#warning {
    background-color: #fd5e00;
    color: white;
    text-align: center;
    position: fixed;
    z-index: 99999;
    width: 100%;
}
</style>

<script>
import { mapState } from 'vuex';
import NodeTree from './NodeTree.vue';
import { injectVKOpenApi, initVK } from '@/utils';

export default {
  name: 'Index',
  data() {
    return {
      currentYear: new Date().getFullYear(),
      initialYear: 2019,
      searchActive: false,
      searchQuery: '',
      initialOffset: 0,
      cookieDisclaimerHide: false,
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    this.initialOffset = document.querySelector('nav#nav').offsetTop;
    this.disclaimerAccept();
    const culturaCounter = document.createElement('script');
    culturaCounter.setAttribute('src', 'https://culturaltracking.ru/static/js/spxl.js?pixelId=6067');
    culturaCounter.setAttribute('data-pixel-id', '6067');
    document.head.appendChild(culturaCounter);
    const widgetGosuslugi1 = document.createElement('script');
    widgetGosuslugi1.setAttribute('src', 'https://pos.gosuslugi.ru/bin/script.min.js');
    document.body.appendChild(widgetGosuslugi1);
    const widgetGosuslugi2 = document.createElement('script');
    widgetGosuslugi2.setAttribute('src', 'https://pos.gosuslugi.ru/form, 337242');
    document.body.appendChild(widgetGosuslugi2);
  },
  computed: mapState({
    menu: state => state.menu,
    banners: state => state.banners,
    announcements: state => state.announcements,
    historyEventsClosest: state => state.historyEventsClosest,
    lastPages: state => state.lastPages,
    copyDate() {
      if (this.currentYear > this.initialYear) {
        return `${this.initialYear}-${this.currentYear}`;
      }
      return `${this.initialYear}`;
    },
  }),
  components: {
    NodeTree,
  },
  methods: {
    disclaimerAccept(userAccept = false) {
      const acceptance = this.$cookie.get('cookie-disclaimer');
      if (userAccept) {
        if (!acceptance) {
          this.$cookie.set('cookie-disclaimer', 1, { expires: '1M' });
        }
        this.cookieDisclaimerHide = true;
      } else {
        this.cookieDisclaimerHide = acceptance === '1';
      }
    },
    fetchData() {
      this.$store.dispatch('loadMenu');
      if (this.$route.name === 'Index') {
        injectVKOpenApi()
          .then(initVK(true))
          .then(() => {
            /* global VK */
            VK.Widgets.Group('vk_groups', { mode: 3, width: 'auto' }, 21880083);
          });
        this.$store.dispatch('loadBanners');
        this.$store.dispatch('loadHistoryEventsClosest');
        this.$store.dispatch('loadАnnouncements');
        this.$store.dispatch('loadLastPages', { limit: 6 });
      }
    },
    navStick(evt, el) {
      if (el) {
        if (window.pageYOffset > this.initialOffset) {
          el.classList.add('sticky');
        } else {
          el.classList.remove('sticky');
        }
      }
    },
    backToTop(evt, el) {
      if (el) {
        if (window.scrollY > 500) {
          el.classList.remove('hidden');
        } else {
          el.classList.add('hidden');
        }
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
  watch: {
    $route: 'fetchData',
    banners: function bannersHandler(banners) {
      if (banners && banners.length > 0) {
        banners.forEach((banner) => {
          this.$set(
            banner,
            'content',
            createElement => (
              createElement('div', {
                class: 'banner-slide',
              }, [
                createElement('a', {
                  attrs: {
                    href: `${banner.uri}`,
                  },
                  class: 'w-100',
                },
                [
                  createElement('img', {
                    attrs: {
                      src: `/static/page_covers/${banner.cover}`,
                    },
                    class: 'banner-image noselect',
                  }),
                  createElement('section', {
                    class: 'banner-desc noselect',
                  },
                  [
                    createElement('h3', {
                      class: 'noselect',
                    }, [`${banner.title}`]),
                    createElement('p', {
                      class: 'line-clamp noselect',
                    }, [`${banner.seo_description}`]),
                  ]),
                ]),
              ])
            ),
          );
        });
      }
    },
    announcements: function bannersHandler(announcements) {
      if (announcements && announcements.length > 0) {
        announcements.forEach((announce) => {
          this.$set(
            announce,
            'content',
            createElement => (
              createElement('div', {
                class: 'announce-slide',
              }, [
                createElement('a', {
                  attrs: {
                    href: `${announce.uri}`,
                  },
                  class: 'w-100',
                },
                [
                  createElement('section', {
                    class: 'noselect',
                  },
                  [
                    createElement('h3', {
                      class: 'noselect',
                    }, [`${announce.title}`]),
                    createElement('p', {
                      class: 'line-clamp noselect m-0',
                    }, [`${announce.seo_description}`]),
                    createElement('a', {
                      attrs: {
                        href: `${announce.uri}`,
                      },
                    }, ['Подробнее']),
                  ]),
                ]),
              ])
            ),
          );
        });
      }
    },
  },
};
</script>
